const ImportDocuments = () => (
    <div className="page-content">
        <h1>Import de documents</h1>
        <p>Bienvenue sur la page Import de documents.</p>
    </div>
);

export default ImportDocuments;